import { useState } from 'react';
import Paper from '@mui/material/Paper';
// import ReactMarkdown from 'react-markdown';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// import Chip from '@mui/material/Chip';
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
// import Tooltip from '@mui/material/Tooltip';
// import HelpTwoTone from '@mui/icons-material/HelpTwoTone';
// import MarkdownParagraphRenderer from '../shared/MarkdownParagraphRenderer';
// import MarkdownUnorderListRenderer from '../shared/MarkdownUnorderedListRenderer';
import PageLayout from '../shared/PageLayout/PageLayout';

const AccountManagement = () => {
	const [value, setValue] = useState(0);
	const [checkboxState, setCheckboxState] = useState({});

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const handleCheckboxChange = event => {
		setCheckboxState({
			...checkboxState,
			[event.target.name]: event.target.checked,
		});
	};

	// 	const markdownContent = `
	// - The Electronic Remittance Advice (ERA), or 835, is the electronic transaction which provides
	// claim payment information in the HIPAA mandated ACSX12 005010X221A1 format. These files are
	// used by practices, facilities, and billing companies to auto-post claim payments into their systems.
	// Benefits include elimination of manual keying and reduction in posting errors; saving time and
	// money.
	// - Enrollment and posting is completed at the Tax ID level. Split routing by clinic location is not
	// available.
	// - Your payment schedule is not impacted by ERA/835 enrollment.
	// - Your remittance advice file may not be immediately available at the time payment is posted.
	// \nPlease allow up to 48 hours for the file to be posted.
	// `;

	const labels = [
		{
			name: 'Eligibility Research Response',
			label: 'Eligibility Research Response',
		},
		{
			name: 'Fitness Center Notification',
			label: 'Fitness Center Notification',
		},
		{
			name: 'General Question Response',
			label: 'General Question Response',
		},
	];

	return (
		<Paper elevation={0} sx={{ py: 2, px: { md: 4, lg: 4 } }}>
			<PageLayout pageTitle='Account Management'>
				<Grid item xs={12}>
					<Tabs
						value={value}
						onChange={handleChange}
						aria-label='account management tabs'
					>
						<Tab label='User Information' />
						{/* after launch, we will add a tab for "Password and Security" */}
					</Tabs>
					{value === 0 && (
						<Box>
							<Typography variant='body1' my={2} mb={5}>
								<strong>Note:</strong> To update your E-mail
								address(es) on file, please contact Customer
								Service.
							</Typography>
							<Grid item xs={12} mb={8}>
								<Typography variant='body1' my={2}>
									<strong>Your Information</strong>
								</Typography>
								<TextField
									disabled
									id='email-address'
									label='Email Address'
									defaultValue='Johnsmith@ashn.com'
									variant='outlined'
								/>
							</Grid>

							<Grid item xs={12} mb={8}>
								<Typography variant='body1' my={2}>
									<strong>E-Mail Notice Preferences</strong>
								</Typography>
								<Typography variant='body1' my={2}>
									ASHLink notifies you via e-mail when
									messages come into your ASHLink inbox. You
									may change which messages you get e-mail
									notification on by checking or unchecking
									the boxes below and click the
									&quot;Update&quot; button.
								</Typography>
								<FormControl
									component='fieldset'
									variant='standard'
								>
									<FormGroup>
										{labels.map(item => (
											<FormControlLabel
												key={item.name}
												control={
													<Checkbox
														checked={
															checkboxState[
																item.name
															] || false
														}
														onChange={
															handleCheckboxChange
														}
														name={item.name}
													/>
												}
												label={item.label}
											/>
										))}
									</FormGroup>
								</FormControl>
							</Grid>
							{/* // NOTE: hidden for 2/10 launch */}
							{/* <Typography variant='body1' my={2}>
								<strong>Electronic Remittance Advice</strong>
								<Tooltip
									tabIndex='0'
									title={
										<Typography variant='subtitle1'>
											<ReactMarkdown
												components={{
													p: MarkdownParagraphRenderer,
													ul: MarkdownUnorderListRenderer,
												}}
											>
												{markdownContent}
											</ReactMarkdown>
										</Typography>
									}
								>
									<HelpTwoTone
										focusable
										aria-hidden='false'
									/>
								</Tooltip>
							</Typography>
							<Typography variant='body1' my={2}>
								Would you like the option of selecting
								Electronic Remittance Advice files in .835
								format?
								<br />
								By selecting &quot;Yes&quot;, you will be able
								to download your .835 Files from the Remittance
								Advice Page.
							</Typography>
							<Box
								sx={{
									display: 'flex',
									alignItems: 'center',
									gap: 1,
								}}
							>
								<Typography variant='body1'>
									Current Status:
								</Typography>
								<Chip
									avatar={
										<Box
											sx={{
												bgcolor: 'green',
												width: 10,
												height: 10,
												borderRadius: '50%',
											}}
										/>
									}
									label='Enrolled'
									variant='outlined'
								/>
							</Box> */}
							{/* <Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									gap: 2,
								}}
							>
								<FormControl>
									<RadioGroup
										aria-labelledby='electronic-remittance-advice-group-label'
										defaultValue='yes'
										name='electronic-remittance-advice-group'
									>
										<FormControlLabel
											value='yes'
											control={<Radio />}
											label='Yes'
										/>
										<FormControlLabel
											value='no'
											control={<Radio />}
											label='No'
										/>
									</RadioGroup>
								</FormControl>
							</Box> */}
							<Grid item xs={12} mb={8}>
								<Typography variant='body1' my={1}>
									<strong>Password and Security</strong>
								</Typography>
								<Box mb={2} sx={{ display: 'block' }}>
									<Link href='/fitness/public/pagenotfound'>
										Change Password or Security Question
									</Link>
								</Box>
								<Box sx={{ display: 'block' }}>
									<Link href='/fitness/public/pagenotfound'>
										Change Two Step Secure Sign-In
									</Link>
								</Box>
							</Grid>
							<Grid container spacing={2} mb={8}>
								<Grid item>
									<Button variant='contained'>
										Save Changes
									</Button>
								</Grid>
								<Grid item>
									<Button variant='outlined'>Cancel</Button>
								</Grid>
							</Grid>
						</Box>
					)}
				</Grid>
			</PageLayout>
		</Paper>
	);
};
export default AccountManagement;
